import { ConfigEntities, ERPDB, QuoteBuilderVersion } from '@prisma/client';
import { z } from 'zod/v4';

import { nullableInt } from '../base';

export const adminSiteUpdateSchema = z.object({
  erpDB: z.enum(ERPDB),
  quoteBuilderVersion: z.enum(QuoteBuilderVersion),
  quoteIdPrefix: z.string().regex(/^[A-Z]{2,3}$/),
  useConfigurator: z.boolean(),
  useImportLineItems: z.boolean(),
  useQuoteWonLossStatus: z.boolean(),
  useEmailSending: z.boolean(),
  consolidateImportedLineItems: z.boolean(),
  siteConfig: z.object({
    configEntityPriorities: z.array(z.enum(ConfigEntities)),
    historicWorkOrderMaxMonthsOld: nullableInt,
    quotingConfigId: z.uuid({ error: 'Quoting Config is required' }),
  }),
});

export type AdminSiteUpdateDefaultFormValues = z.input<
  typeof adminSiteUpdateSchema
>;

export type AdminSiteUpdateFormData = z.output<typeof adminSiteUpdateSchema>;
